import dynamic from "next/dynamic";
import Head from "next/head";

const PaymentWrapper = dynamic(() => import("@components/Components/CheckoutComponent/Payment/Payment"), {
  ssr: false,
})


const Payment = ({paymentData}) => {
  return (
    <>
      <Head>
        <title>{`${process.env.brand.brand_name} - Checkout - Payment`}</title>
        <meta
            name="description"
            content={`${process.env.brand.brand_name} offer furniture hire, chair hire and table hire at exceptional prices throughout London and the UK. Order online now.`}
        />
      </Head>

      <PaymentWrapper template_page_settings={paymentData?.template_page_settings}/>

  </>
  )
}

export async function getServerSideProps() {
  const paymentReq = await fetch(`${process.env.BASE_API_URL}checkout/payment`);
  const paymentData = await paymentReq.json()

  // Pass data to the page via props
  return { 
    props: { paymentData },
  }
}


export default Payment